import {createUseStyles} from "react-jss";
import {colors, buttons, space} from "../../theme";


export const useStyles = createUseStyles({
    component: {
        display: "flex",
        gap: space(2),
        border: `1px solid ${colors.neutral30}`,
        padding: space(4),
        "&:hover": {
            borderColor: colors.neutral50,
        },
    },
    relation: {
        "--relation-color": colors.primary,
        "--relation-hover-color": colors.primaryDark,
        display: "flex",
        borderRight: "4px solid var(--relation-color)",
        paddingRight: space(2),
        paddingBlock: space(4),
    },
    relation_and: {
        "--relation-color": "#1E88E5",
        "--relation-hover-color": "#1565C0",
    },
    relation_or: {
        "--relation-color": "#FFC107",
        "--relation-hover-color": "#FFB300",
        borderRightStyle: "dotted",
    },
    relationButton: {
        "--button-color": "var(--relation-color) !important",
        "--button-hover-color": "var(--relation-hover-color) !important",
        width: 60,
        alignSelf: "center",
    },
    entries: {
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        justifyContent: "center",
        gap: space(2),
    },
    entry: {
        display: "flex",
        gap:space(2),
    },
    entryControls: {
        display: "flex",
        alignContent: "center",
    },
    entryDelete: {
        alignSelf: "center",
    },
    addWrapper: {
        display: "flex",
        gap: space(4),
    },
    addEntryButton: {
        fontWeight: "normal",
    }
});